export default "__VITE_ASSET__CVY9EjgH__"